import styled, {css} from "styled-components"
import {minWidthMedia} from "@irati/ui/src/global/media"
import Flex from "@irati/ui/src/Flex"

interface Props {
  onClick?: () => void
  noBorder?: boolean
}

export const StyledContainer = styled(Flex)`
  flex-direction: column;
  ${minWidthMedia.tablet`
    flex-direction: row;
  `}
`

export const StepIndicatorHeader = styled(Flex)`
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    flex-direction: row;
  `}
`

export const OccasionIcon = styled.img`
  ${({theme}) => css`
    width: ${theme.spacing.three};
    height: ${theme.spacing.three};
    margin-right: ${theme.spacing.one};
  `}
`

export const SelectedRecognitionValue = styled.div`
  display: inline-flex;
  margin-right: ${({theme}) => theme.spacing.half};
  align-items: center;
  ${({theme}) => css`
    padding: ${theme.spacing.half} ${theme.spacing.two};
    background-color: ${theme.colors.greys.lightest};
    border-radius: ${theme.spacing.two};
  `}
`

export const ExpiringSoon = styled(Flex)<Props>`
  align-items: center;
  flex: 1;
  ${({theme, onClick, noBorder}) => css`
    cursor: ${onClick && "pointer"};
    background-color: ${theme.colors.greys.white};
    border: ${noBorder ? "none" : `1px solid ${theme.colors.tertiary.o_200}`};
    border-radius: ${theme.border.radius.large};
    padding: ${theme.spacing.one};
  `}
`
